export default "assets/images/arrow-up-009ea1e2.svg";